import signedFetch from '../../../apiCalls/util/signedFetch.js';

export default function* productPublishApi(selectedPlatformCode) {
  const body = { platform: selectedPlatformCode };

  return yield signedFetch('publish', `${__API_BASE__}/product-metadata/publish`, 'POST', body);
}
